//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import CFooter from "@/common/Footer"
export default{
  data(){
    return{
      showA: '-1',
      productList:[
        {
          title: '专用服务器，专用线路',
          subTil: ' 基于云计算的虚拟主机服务',
          content: '免费虚拟主机采取专用服务器，和付费服务器完全隔离，保 障了彼此之间互不影响。',
        },
        {
          title: '永久免费，永久零费用',
          subTil: '极速稳定高弹性的计算服务',
          content: '免费虚拟主机不需要交纳一分钱即可开通使用，使用过程中 通过免费延期，后续也无需缴纳任何费用。',
        },
        {
          title: '实时在线添加，永久免费',
          subTil: '提供五星级的域名注册服务',
          content: '在免备案服务中，选择您开通的产品，在线实时添加域名， 系统将给出免备案的解析地址。',
        },
        {
          title: '实时在线开通',
          subTil: '国内免费空间第一品牌',
          content: '免费的目的是给用户体验、练习、以及建设非商业化的个人 网站使用，可以永久免费，但不能直接升级到付费主机。',
        },
        {
          title: '送免备案系统',
          subTil: '国内免费空间第一品牌',
          content: '阿贝云推出独创的免备案服务，您的域名可以暂时不备案，直接使用，备案后速度更快更稳定。',
        },
      ]
    }
  },
  components: {
    CFooter
  },
  methods:{
    listDown(d) {
      if(this.showA == d) {
        this.showA = '-1'
      } else {
        this.showA = d
      }
    },
  }
}



// WEBPACK FOOTER //
// ./src/components/user/freevhost.vue